import { render, staticRenderFns } from "./ClubhouseDialog.vue?vue&type=template&id=c38ec64a&scoped=true"
import script from "./ClubhouseDialog.vue?vue&type=script&lang=js"
export * from "./ClubhouseDialog.vue?vue&type=script&lang=js"
import style0 from "./ClubhouseDialog.vue?vue&type=style&index=0&id=c38ec64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38ec64a",
  null
  
)

export default component.exports